<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 md10 offset-md1>
   			<v-card>
	   			<v-card-title>

            <v-text-field v-model="filter.id" label="LTP No." class="mr-3"></v-text-field>
            <v-text-field v-model="filter.title" label="LTP Name" class="mr-3"></v-text-field>
            <v-text-field v-model="filter.mobile" label="Mobile No." class="mr-3"></v-text-field>
            <search-btn @click="filterData" />

            <v-spacer></v-spacer>
            <v-btn v-on:click="dialog = true" round color="primary" dark small class="ml-4" v-if="hasCreateAccess">Add New</v-btn>
            
            <agent-form v-bind:editingItem.sync="editingItem" v-bind:active.sync="dialog" @success="processList" />

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="agents"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <td>{{ props.item.title }}</td>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.city_name }}</td>
              <td>{{ props.item.state_name }}</td>
              <td>{{ props.item.country_name }}</td>
				      <td>{{ props.item.mobile }}</td>
              <td class="align-center justify-center layout px-0">
                <edit-btn :item="props.item" />
                <delete-btn :item="props.item" />
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !agents.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(agents)" />

			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  import AgentForm from './AgentCreate'

  export default {
    name: 'Agents',
    data () {
      return {
        model: 'agent',
      	title: "Agents",
      	processing: false,
        dialog: false,
        deleteDialog: false,
      	agents: [],
        editingItem: null,
        headers: [
          { text: 'Name', value: 'title'},
          { text: 'LTP No.', value: 'id'},
          { text: 'City', value: 'city_name'},
          { text: 'State', value: 'state_name'},
          { text: 'Country', value: 'country_name'},
          { text: 'Mobile', value: 'mobile'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        filter: {
          id: "",
          title: "",
          mobile: ""
        }
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'LTP',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage LTP')
    },
    methods: {

      loadPage () {

        let api_path = this.config.apis.getAgents.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)

        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          filterArray.push(`${key}=${val}`)
        }

        api_path += '?' + filterArray.join('&')

        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.agents = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.agents = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      editItem (item) {
        this.editingItem = item
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
        }, 300)
      },

      processList (item) {
        let index = this.agents.findIndex(obj => item.id === obj.id)
        index === -1 ? this.agents.unshift(item) : this.agents.splice(index, 1, item)
      }

    },
    mounted () {
      
    },

    computed: {

    },

    watch: {

    },

    components: {
      'agent-form': AgentForm
    }

  }
</script>
